<template>
  <b-form-group
    label="Buton Etiketi"
    label-for="button"
  >
    <b-form-input
      id="button"
      v-model="itemData.button"
      placeholder="Buton Etiketi"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'ButtonLabel',
  components: { BFormInput, BFormGroup },
  computed: {
    itemData() {
      return this.$store.getters['carousel/dataItem']
    },
  },
}
</script>
